import {useState, useEffect} from 'react'
import moment from 'moment'
import {ICandidate} from './types/candidate'

export const validDate = (inputDate?: string | Date) => {
  if (typeof inputDate === 'string') {
    const date = moment(inputDate, 'D.M.YYYY', true)
    const correctDate = date.isValid() ? date : inputDate.length >= 10 ? moment(inputDate) : undefined
    return correctDate && correctDate.isValid() ? correctDate.toDate() : undefined
  }
  return inputDate || undefined
}

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
  return emailRegex.test(email)
}

interface IHandler {
  (event: {target: any}): void
  (event: {target: any}): void
  (this: Document, ev: MouseEvent): any
  (this: Document, ev: TouchEvent): any
}

/**
 * Click/Touch handler
 *
 * Add/Remove event listeners based on ref target. Used for dropdown.
 */

export const useClickOutside = (ref: {current: any}, onClickOutside: (e: any) => void, isActive: any) => {
  const [isListening, setListening] = useState(false)
  const handler = (event: {target: any}) => {
    const {current: el} = ref
    if (el && event.target && (event.target instanceof HTMLElement || event.target instanceof SVGElement) && !el.contains(event.target)) {
      onClickOutside(event)
    }
  }
  const addHandlers = (handler: IHandler) => {
    document.addEventListener('mousedown', handler)
    document.addEventListener('touchstart', handler)
  }
  const removeHandlers = (handler: IHandler) => {
    document.removeEventListener('mousedown', handler)
    document.removeEventListener('touchstart', handler)
  }
  useEffect(() => {
    if (!isListening && isActive) {
      addHandlers(handler)
      setListening(true)
    } else if (isListening && !isActive) {
      removeHandlers(handler)
      setListening(false)
    }
    return () => {
      removeHandlers(handler)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, !onClickOutside, isActive])
}

export const createCandidateElectionData = (candidate: ICandidate) => {
  if (!Object.keys(candidate?.election_data || {}).length) return {}
  return Object.keys(candidate.election_data).reduce((acc, key) => {
    if (Object.keys(candidate.election_data[key]).length) {
      acc[key] = {
        constituency_id: candidate.election_data[key].constituency_id,
        party_id: candidate.election_data[key].party_id
      }
    }
    return acc
  }, {})
}
